import React, { useState, useRef } from 'react';
import { Trip } from '@/types';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import TripDashboardSection from '../TripDashboardSection';
import TravellerList from '@/components/traveller/TravellerList';
import TravellerViewModeToggle from '@/components/traveller/TravellerViewModeToggle';
import AddTravellerForm from '@/components/traveller/AddTravellerForm';
import { useI18n } from '@/hooks/useI18n';

interface TripTravellersPageProps {
    trip: Trip;
}

const TripTravellersPage: React.FC<TripTravellersPageProps> = ({ trip }) => {
    const [viewMode, setViewMode] = useState<'grid' | 'table'>('grid');
    const triggerRef = useRef<HTMLButtonElement>(null);
    const { t } = useI18n();

    const travellerActions = (
        <TravellerViewModeToggle
            viewMode={viewMode}
            onViewModeChange={setViewMode}
        />
    );

    return (
        <>
            <TripDashboardSection
                icon="👥"
                title={t('trip.dashboard.tabs.travellers')}
                subtitle={t('trip.pages.travellers.subtitle')}
                description={t('trip.pages.travellers.description')}
                secondaryActions={travellerActions}
                primaryAction={{
                    icon: <Add />,
                    onClick: () => {
                        triggerRef.current?.click();
                    },
                    label: t('trip.pages.travellers.addTraveller')
                }}
            >
                <TravellerList trip={trip} currentViewMode={viewMode} />
            </TripDashboardSection>

            <AddTravellerForm
                trip={trip}
                trigger={
                    <Button 
                        ref={triggerRef}
                        style={{ display: 'none' }}
                    >
                        {t('trip.pages.travellers.hidden')}
                    </Button>
                }
            />
        </>
    );
};

export default TripTravellersPage;
